import { render, staticRenderFns } from "./permission-group.form.vue?vue&type=template&id=21b0ada0&"
import script from "./permission-group.form.vue?vue&type=script&lang=ts&"
export * from "./permission-group.form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports